type StateControllerSetupService = {
    setViewPreference(stateName: string): void;
};

/** Persists home tab preference when dash becomes active (delegates to StateControllerSetup.setViewPreference). */
export function persistDashViewPreferenceIfLoggedIn(): void {
    const stateControllerSetup = window.angBridge?.$injector?.get("StateControllerSetup") as
        | StateControllerSetupService
        | undefined;
    stateControllerSetup?.setViewPreference("dash");
}
